import { render, staticRenderFns } from "./project-report-dialog.vue?vue&type=template&id=5e16904a"
import script from "./project-report-dialog.vue?vue&type=script&lang=js"
export * from "./project-report-dialog.vue?vue&type=script&lang=js"
import style0 from "./project-report-dialog.vue?vue&type=style&index=0&id=5e16904a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports